import axios from 'axios'
import axiosRetry from 'axios-retry'

const AxiosWithRetries = retries => {
    const axiosInstance = axios.create()

    axiosRetry(axiosInstance, {
        retries,
        retryDelay: retryCount => retryCount * 1000,
        retryCondition: error => {
            return (
                error.message === 'Network Error' || // Network error
                error.code === 'ECONNABORTED' || // Timeout
                error.code === 'ECONNREFUSED' || // Server not running
                (error.response && error.response.status >= 500)
            )
        },
        shouldResetTimeout: true,
    })

    return axiosInstance
}

export default AxiosWithRetries
